module.exports = __webpack_public_path__ + "static/media/play-store-white.2cff7cff.png";